import { render, staticRenderFns } from "./checkboxStaff.vue?vue&type=template&id=7a3f1766"
import script from "./checkboxStaff.vue?vue&type=script&lang=js"
export * from "./checkboxStaff.vue?vue&type=script&lang=js"
import style0 from "./checkboxStaff.vue?vue&type=style&index=0&id=7a3f1766&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports